import * as Yup from "yup";
import { expenseValidationSchema } from "./expenseValidationSchema";
import { ShowDealType, ShowStatus } from "@quantizr-engineering/common/types/show";

export const showValidationSchema = Yup.object().shape({
  performanceDate: Yup.date().required("Performance date is required as Date"),
  city: Yup.string().nullable(),
  state: Yup.string().nullable(),
  venue: Yup.string().nullable(),
  deposits: Yup.array()
    .of(
      Yup.object().shape({
        amount: Yup.number().required("Amount is required"),
      })
    )
    .default([]),
  location: Yup.string().nullable(),
  description: Yup.string().nullable(),
  promoter: Yup.string().nullable(),
  guarantee: Yup.number()
    .nullable()
    .transform((value) => (isNaN(value) ? null : value)),
  walkoutPotential: Yup.number()
    .nullable()
    .transform((value) => (isNaN(value) ? null : value)),
  productionBuyouts: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().required("Name is required as"),
        amount: Yup.number().required("Amount is required"),
      })
    )
    .nullable()
    .default([]),
  deductions: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().required("Name is required"),
        amount: Yup.number().required("Amount is required"),
      })
    )
    .nullable()
    .default([]),
  dealType: Yup.string()
    .oneOf(Object.values(ShowDealType), "Invalid deal type")
    .default(ShowDealType.REV_SPLIT),
  status: Yup.string()
    .oneOf(Object.values(ShowStatus), "Invalid show status")
    .default(ShowStatus.DRAFT),
  profitSharePercent: Yup.number()
    .nullable()
    .transform((value) => (isNaN(value) ? null : value))
    .when("dealType", {
      is: ShowDealType.REV_SPLIT,
      then: (schema) =>
        schema.required(
          "Profit share percentage is required for Revenue Share deals"
        ),
    }),
  ticketTypes: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().required("Ticket name is required"),
        quantity: Yup.number().required("Quantity is required"),
        price: Yup.number().required("Price is required"),
        charityFee: Yup.number().default(0),
        facilityFee: Yup.number().default(0),
        soldProjected: Yup.number().default(0),
        sold: Yup.number().default(0),
      })
    )
    .nullable()
    .default([]),
  ticketBonuses: Yup.array()
    .of(
      Yup.object().shape({
        bonusAmount: Yup.number().nullable(),
        bonusPercent: Yup.number().nullable(),
        threshold: Yup.number().nullable(),
        thresholdPercent: Yup.number().nullable(),
      })
    )
    .nullable()
    .default([]),
  expenses: Yup.array().of(expenseValidationSchema).nullable().default([]),
  merchSoft: Yup.number().default(0),
  merchHard: Yup.number().default(0),
  additionalPoints: Yup.array().of(Yup.string()).nullable(),
  tax: Yup.number()
    .nullable()
    .transform((value) => (isNaN(value) ? null : value)),
  appearingWith: Yup.string().nullable(),
  commissions: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().required("Name is required"),
        percent: Yup.number().nullable(),
        commissionBuyout: Yup.number().nullable(),
        flatFee: Yup.number().nullable(),
      })
    )
    .nullable()
    .default([]),
  ticketAdjustments: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().required("Name is required"),
        notes: Yup.string().nullable(),
        addToGross: Yup.boolean().default(false),
        amount: Yup.number().required("Amount is required"),
      })
    )
    .nullable()
    .default([]),
});
